import noop from 'lodash/noop';
import { ReactElement, useCallback } from 'react';

import { Icd10Code } from '@dreryk/egabinet-icd-dictionary-published-language-api';
import { VisitDiagnosisMarkAsMainCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor } from '@dreryk/react-components';

import { useVisitDiagnosisFaultHandlerMap, VisitDiagnosisCommonFault } from './shared/useVisitDiagnosisFaultHandlerMap';

type VisitDiagnosisMarkAsMainEventInterceptorProps = {
   readonly children: ReactElement;
   readonly visitId: number;
   readonly code: string;
   readonly enabled: boolean;
};

// eslint-disable-next-line max-lines-per-function
export const VisitDiagnosisMarkAsMainEventInterceptor = (
   props: VisitDiagnosisMarkAsMainEventInterceptorProps
): JSX.Element => {
   const { executeAsync: markAsMain } = useCqrsCommand<void, void, VisitDiagnosisCommonFault>(
      () => {
         const command = new VisitDiagnosisMarkAsMainCommand();
         command.visitId = props.visitId;
         command.code = Icd10Code.of(props.code);
         return command;
      },
      {
         onFault: useVisitDiagnosisFaultHandlerMap(),
      }
   );

   // eslint-disable-next-line @typescript-eslint/require-await
   const action = useCallback(async (): Promise<void> => {
      if (!props.enabled) {
         return noop();
      }

      return markAsMain();
   }, [markAsMain, props.enabled]);

   return <ActionEventInterceptor action={action}>{props.children}</ActionEventInterceptor>;
};
